module.exports = __webpack_public_path__ + "static/media/undraw_server_status_5pbv_green.c4199972.svg";